export function parseAemContent(encodedContent: string): {
  title: string;
  description: string;
} {
  // Decode HTML entities
  const textarea = document.createElement('textarea');
  textarea.innerHTML = encodedContent;
  const decodedContent = textarea.value;

  // Create temporary element to parse HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = decodedContent;

  // Extract title from strong tag
  const strongElement = tempDiv.querySelector('strong');
  const title = strongElement ? strongElement.textContent || '' : '';

  // Remove strong and br elements
  if (strongElement) {
    strongElement.remove();
  }
  const brElements = tempDiv.querySelectorAll('br');
  brElements.forEach((br) => br.remove());

  // Get description with HTML preserved (anchor tags kept)
  const description = tempDiv.innerHTML.replace(/\s+/g, ' ').trim();

  return {
    title: title.trim(),
    description: description
  };
}
